<template>
  <div class="dataDirectory">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <!-- 标题 -->
        <span style="font-size: 24px" class="font-sz24">资料目录配置</span>
        <div class="head-text" style="float: right; margin-top: -4px">
          <el-button @click="batchAddFile = true" type="primary" style="float: right" class="float-r"
            size="medium">资料目录导入</el-button><el-button @click="exportExcel" type="success" size="medium"
            style="float: right; margin-right: 10px" class="float-r-mar-r10">资料目录导出</el-button>
        </div>
      </div>

      <el-container>
        <!-- 这里是侧边栏-->
        <div style="margin-top: 20px" class="mar-top20">
          <el-aside width="200px" style="
              border: 1px solid #dcdfe6;
              border-radius: 4px;
              text-align: center;
            " class="elAside">
            <el-button type="primary" size="small" @click="showAll">显示全部目录</el-button>
            <div class="zTreeDiv">
              <ul id="ProjectFileTree" class="ztree"></ul>
            </div>
            <div id="ProjectFileRemenu">
              <ul>
                <li id="addProjectFile">添加</li>
                <li id="updateProjectFile">修改</li>
                <li id="delProjectFile">删除</li>
                <li id="visibleProjectFile">设置</li>
              </ul>
            </div>
          </el-aside>
        </div>
        <el-main>
          <div class="rygl-table">
            <el-table :data="inform" style="width: 100%; margin-bottom: 20px" class="margin-20 table w100-mar-bom20"
              height="72vh" v-loading="tableLoading">
              <el-table-column align="center" prop="label" label="名称"></el-table-column>
              <el-table-column align="center" prop="Count" label="文件数量"></el-table-column>
              <el-table-column align="center" prop="user" label="维护人员"></el-table-column>
              <el-table-column align="center" prop="DateTime" label="更新时间"></el-table-column>
            </el-table>

            <el-table :data="inform" style="width: 100%; margin-bottom: 20px"
              class="margin-20 table daochu w100-mar-bom20" height="72vh" v-show="daochu">
              <el-table-column label="Id" align="center" prop="ID"></el-table-column>
              <el-table-column align="center" prop="label" label="名称"></el-table-column>
              <el-table-column label="父节点" align="center" prop="ParentId"></el-table-column>
              <el-table-column label="备注" align="center" prop="Content"></el-table-column>
              <el-table-column label="排序" align="center" prop="order"></el-table-column>
            </el-table>
          </div>
        </el-main>
      </el-container>
    </el-card>
    <!-- 批量文件添加节点 -->
    <el-dialog :close-on-click-modal="false" title="导入节点" :visible.sync="batchAddFile" width="40%" center>
      <p>
        点击下载模板文件：
        <a style="color: red" class="cor-red" :href="$store.state.baseUrl + '/UploadFiles/资料目录树.xlsx'"
          target="_blank">示例表格.XLSX</a>并按要求填好后上传
      </p>
      <!-- <p>"注意：选项均不能为空，计划开始时间小于等于计划开始时间，时间格式：2020-02-21 14:00任务占比总和必须为100
      请按照上述要求填写，否则会导致上传失败！</p>-->
      <el-upload ref="upload" class="upload-demo" :action="actionUrl" :on-change="handleChange" :file-list="fileList"
        :limit="1" :data="nodeFileData" :before-upload="beforeUpload" accept=".xlsx" :auto-upload="false"
        :on-success="uploadSuccess" :headers="importHeaders" :on-exceed="handleExceed">
        <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
        <el-button style="margin-left: 10px" class="mar-left10" size="small" type="success"
          @click="submitUpload">上传到服务器</el-button>
        <div slot="tip" class="el-upload__tip">只能上传xlsx文件</div>
      </el-upload>
    </el-dialog>

    <!-- 人员选择 -->
    <el-dialog :close-on-click-modal="false" title="设置可见人员/审核" :visible.sync="visibleProjectFileShow" width="80%" center>
      <el-container>
        <!-- 这里是侧边栏-->
        <div style="margin-top: 20px">
          <el-aside width="200px" style="
              border: 1px solid #dcdfe6;
              border-radius: 4px;
              text-align: center;
            " class="elAside">
            <el-button type="primary" size="small" @click="showAll2">显示全部成员</el-button>
            <div class="zTreeDiv">
              <ul id="PdeptTree" class="ztree" style="height: 700px"></ul>
            </div>
          </el-aside>
        </div>
        <!-- 这里是内容显示区域 -->

        <el-main>
          <el-row type="flex" style="padding: 5px 20px">
            <el-col class="middle" :span="4">当前节点是否需要审核：</el-col>
            <el-col :span="20">
              <el-radio-group v-model="selectNode.pftr10">
                <el-radio label="1" border>是</el-radio>
                <el-radio label="0" border>否</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
          <el-row type="flex" style="padding: 5px 20px">
            <el-col class="middle" :span="2">已选择人员：</el-col>
            <el-col :span="22">
              <el-select v-model="selectUserIds" multiple filterable clearable style="width: 100%"
                @remove-tag="delSelectUser" @change="changeSelectUser" placeholder="不选择则为全部可见">
                <el-option v-for="item in allUsers" :key="item.value" :label="item.user04" :value="item.user01">
                </el-option> </el-select></el-col>
          </el-row>

          <el-button type="success" style="margin-left: 15px" @click="submitVisibleUser">提交</el-button>

          <div class="rygl-table">
            <el-table class="margin-20 table" v-loading="loading" :data="communication" height="72vh" style="width: 100%"
              @selection-change="handleSelectionChange">
              <el-table-column align="center" type="selection" width="55"></el-table-column>
              <el-table-column type="index" align="center" label="序号" width="80"></el-table-column>
              <el-table-column align="center" prop="user02" label="账号"></el-table-column>
              <el-table-column align="center" prop="user04" label="姓名"></el-table-column>
              <el-table-column align="center" prop="prde03" label="所属组织"></el-table-column>
              <el-table-column align="center" prop="pror02" label="岗位"></el-table-column>
              <el-table-column align="center" prop="user12" label="邮箱">
                <template slot-scope="scope">{{
                  ($store.state.permissions != null &&
                    !$store.state.permissions.includes("1012")) ||
                  $store.state.isProject
                  ? scope.row.user12
                  : "**************"
                }}
                </template>
              </el-table-column>
              <el-table-column align="center" prop="user11" label="手机号">
                <template slot-scope="scope">{{
                  ($store.state.permissions != null &&
                    !$store.state.permissions.includes("1011")) ||
                  $store.state.isProject
                  ? scope.row.user11
                  : "**************"
                }}</template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" align="center"
              style="margin-top: 30px" :current-page="pagenum" :page-sizes="[10, 50, 100]" :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
          </div>
        </el-main>
      </el-container>
    </el-dialog>
  </div>
</template>

<script>
// excel导出
import FileSaver from "file-saver";
import XLSX from "xlsx";
import {
  GetProjectFileTree,
  GetProjectFileZTree,
  AddProjectFile,
  EditProjectFile,
  DelProjectFile,
  ChangeProjectFileOrder,
  FindProjectFileInfo,
  GetDeptUser,
  GetProjectdeptZTree,
  submitVisibleUser,
} from "@/setAxios.js";
export default {
  name: "ProjectInformation",
  data() {
    return {
      //人员显示开始----
      loading: false,
      pagesize: 10,
      pagenum: 1,
      total: 0,
      menuData: [],
      communication: [],
      zTeeObj2: null,
      ids2: "null",
      visibleProjectFileShow: false,
      allUsers: [],
      selectUsers: [],
      selectUserIds: [],
      //人员显示结束----
      daochu: false,
      actionUrl: this.$store.state.baseUrl + "/api/ImportDataExcel",
      importHeaders: { token: localStorage.getItem("token") },
      fileList: [],
      nodeFileData: {
        projectId: localStorage.xid,
        uid: localStorage.id,
      },
      batchAddFile: false,
      inform: [],
      tableLoading: false,
      ids: "null",
      zNodes: null,
      selectNode: {},
      selectNodes: [],
      zTeeObj: null,
    };
  },
  methods: {
    //人员显示开始--------------------------------------
    //去重
    unique(arr, val) {
      const res = new Map();
      return arr.filter((item) => !res.has(item[val]) && res.set(item[val], 1));
    },
    submitVisibleUser() {
      if (this.selectNodes.length > 1) {
        this.$confirm(
          "检测到当前资料目录节点下有子节点，当前设置是否应用子节点?",
          "提示",
          {
            confirmButtonText: "是",
            cancelButtonText: "否",
            type: "warning",
          }
        )
          .then(() => {
            this.submitVisibleUserAxios();
          })
          .catch(() => {
            this.selectNodes = [this.selectNodes[0]];
            this.submitVisibleUserAxios();
          });
      } else {
        this.submitVisibleUserAxios();
      }
    },
    submitVisibleUserAxios() {
      let params = {
        fids: this.selectNodes.join(","),
        uids: this.selectUserIds.length ? this.selectUserIds.join(",") : null,
        pftr10: this.selectNode.pftr10,
      };
      submitVisibleUser(params).then((res) => {
        if (res.Code) {
          this.$message.success("修改成功");
          this.visibleProjectFileShow = false;
          this.selectNodes = [];
          this.selectUserIds = [];
          this.selectUsers = [];
          this.GetProjectFileZTree();
        }
      });
    },
    changeSelectUser(data) {
      this.selectUsers = this.allUsers.filter((x) => data.includes(x.user01));
      this.selectUserIds = this.selectUsers.map((item) => item.user01);
    },
    delSelectUser(data) {
      this.selectUsers = this.selectUsers.filter((x) => x.user01 != data);
      this.selectUserIds = this.selectUsers.map((item) => item.user01);
    },
    handleSelectionChange(ids) {
      this.selectUsers = this.selectUsers.concat(ids);
      this.selectUsers = this.unique(this.selectUsers, "user01");
      this.selectUserIds = this.selectUsers.map((item) => item.user01);
    },
    showAll2() {
      this.ids2 = "null";
      this.GetDeptUser();
    },
    //初始化ztree
    init2() {
      var _this = this;
      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: true,
        },
        data: {
          key: {
            name: "prde03",
          },
          simpleData: {
            enable: true,
            idKey: "prde01",
            pIdKey: "prde07",
          },
        },
        callback: {
          onCheck: onCheck,
          onClick: onclick,
        },
      };
      this.zTeeObj2 = $.fn.zTree.init($("#PdeptTree"), setting, this.menuData);

      this.zTeeObj2.checkAllNodes(true);

      var checkedNodes = this.zTeeObj2.getCheckedNodes();
      _this.ids2 = "";
      var _split = "";
      checkedNodes.forEach((element) => {
        _this.ids2 += _split + element.prde01;
        _split = ",";
      });
      _this.GetDeptUser();
      // 选中状态
      function onCheck() {
        var checkedNodes = _this.zTeeObj2.getCheckedNodes();
        _this.ids2 = "";
        var _split = "";
        checkedNodes.forEach((element) => {
          _this.ids2 += _split + element.prde01;
          _split = ",";
        });
        _this.GetDeptUser();
      }
      //点击事件
      function onclick(event, treeId, treeNode) {
        _this.pagenum = 1;
        _this.ids2 = treeNode.prde01;
        _this.GetDeptUser();
      }
    },

    handleNodeClick(data) {
      this.pagenum = 1;
      this.bid = data.ID;
      this.GetDeptUser();
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.GetDeptUser();
    },
    handleCurrentChange(val) {
      this.pagenum = val;
      this.GetDeptUser();
    },
    getData2() {
      let params = {
        id: localStorage.getItem("xid"),
      };
      GetProjectdeptZTree({ params }).then((res) => {
        this.menuData = res.Data;
        this.init2();
      });
    },
    GetDeptUser() {
      this.loading = true;
      let params = {
        xid: localStorage.getItem("xid"),
        bid: this.ids2,
        cid: localStorage.getItem("pid"),
        pageIndex: this.pagenum,
        pageSize: this.pagesize,
      };
      GetDeptUser({ params }).then((res) => {
        this.loading = false;
        this.total = res.Data.total;
        this.communication = res.Data.list;
      });
    },
    getAllUser() {
      let params = {
        xid: localStorage.getItem("xid"),
        bid: "null",
        cid: localStorage.getItem("pid"),
        pageIndex: 1,
        pageSize: 99999,
      };
      GetDeptUser({ params }).then((res) => {
        this.allUsers = res.Data.list;
      });
    },
    //人员显示结束--------------------------------------

    // 导出表格所用
    exportExcel() {
      this.daochu = true;
      // 设置当前日期
      let time = new Date();
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      let name = year + "" + month + "" + day;
      var wb = XLSX.utils.table_to_book(document.querySelector(".daochu"));
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          name + ".xlsx"
        );
      } catch (e) { }
      this.daochu = false;
      return wbout;
    },
    submitUpload() {
      if (this.fileList.length > 0) {
        this.$refs.upload.submit();
      } else {
        this.$message({
          type: "warning",
          message: "请选择文件后上传",
        });
      }
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    beforeUpload(file) {
      let fd = new FormData();
      fd.append("file", file);
      fd.append("nodeFileData", JSON.stringify(this.nodeFileData));
      var index = file.name.lastIndexOf(".");
      var suffix = file.name.substring(index + 1);
      const extension = suffix === "xlsx";
      //(suffix);
      if (!extension) {
        this.$message({
          message: "上传文件只能是 xlsx格式!",
          type: "warning",
        });
        this.loading2 = false;
      }
      return extension;
    }, // 上传成功
    uploadSuccess(data) {
      this.loading2 = false;
      if (data.Code > 0) {
        this.$message({
          type: "success",
          message: "上传成功",
        });
        this.batchAddFile = false;
        this.modelList();
      } else {
        this.$message({
          type: "warning",
          message: data.Message,
        });
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
        } 个文件`
      );
    },
    showAll() {
      this.zTeeObj.checkAllNodes(true);
      var checkedNodes = this.zTeeObj.getCheckedNodes();
      this.ids = "";
      var _split = "";
      checkedNodes.forEach((element) => {
        this.ids += _split + element.pftr01;
        _split = ",";
      });
      this.getData();
    },
    //初始化ztree
    init() {
      var _this = this;

      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: true,
        },
        data: {
          key: {
            name: "pftr02",
          },
          simpleData: {
            enable: true,
            idKey: "pftr01",
            pIdKey: "pftr03",
          },
        },
        edit: {
          enable: true,
          showRemoveBtn: false,
          showRenameBtn: false,
          drag: {
            isMove: true,
            inner: true,
            prev: false,
            next: true,
          },
        },
        callback: {
          onRightClick: OnRightClick,
          beforeRename: beforeRename,
          beforeDrop: beforeDrop,
          onCheck: onCheck,
          onClick: onclick,
        },
      };

      this.zTeeObj = $.fn.zTree.init(
        $("#ProjectFileTree"),
        setting,
        this.zNodes
      );
      this.zTeeObj.checkAllNodes(true);
      var checkedNodes = this.zTeeObj.getCheckedNodes();
      _this.ids = "";
      var _split = "";
      checkedNodes.forEach((element) => {
        _this.ids += _split + element.pftr01;
        _split = ",";
      });
      _this.getData();
      // 选中状态
      function onCheck() {
        var checkedNodes = _this.zTeeObj.getCheckedNodes();
        _this.ids = "";
        var _split = "";
        checkedNodes.forEach((element) => {
          _this.ids += _split + element.pftr01;
          _split = ",";
        });
        _this.getData();
      }
      // 拖拽功能
      function beforeDrop(treeId, treeNodes, targetNode, moveType) {
        var moveNode = treeNodes[0];
        switch (moveType) {
          case "prev":
          case "next":
          case "inner":
            ChangeProjectFileOrder({
              oid: moveNode.pftr01,
              nid: targetNode.pftr01,
              moveType: moveType,
            });
            _this.$message({
              type: "success",
              message: "移动成功",
            });
            return true;
            break;
        }
        return false;
      }
      //点击事件
      function onclick(event, treeId, treeNode) {
        _this.ids = treeNode.pftr01;
        _this.getData();
      }
      function getChildren(ids, treeNode) {
        ids.push(treeNode.pftr01);
        if (treeNode.isParent) {
          for (var obj in treeNode.children) {
            getChildren(ids, treeNode.children[obj]);
          }
        }
        return ids;
      }
      // 在ztree上的右击事件
      function OnRightClick(event, treeId, treeNode) {
        _this.selectNode = treeNode;
        _this.selectNodes = [];
        if (treeNode) {
          _this.selectNode.pftr10 = treeNode.pftr10 + "";
          _this.selectNodes = getChildren(_this.selectNodes, treeNode);
        }
        if (treeNode == null) {
          showRMenu("root", event.clientX, event.clientY);
        } else {
          showRMenu("node", event.clientX, event.clientY);
        }
      }
      //鼠标按下事件
      function onBodyMouseDown(event) {
        if (
          !(
            event.target.id == "ProjectFileRemenu" ||
            $(event.target).parents("#ProjectFileRemenu").length > 0
          )
        ) {
          $("#ProjectFileRemenu").css({ visibility: "hidden" });
        }
      }
      //显示右键菜单
      function showRMenu(type, x, y) {
        if (type == "root") {
          $("#addProjectFile").show();
          $("#updateProjectFile").hide();
          $("#delProjectFile").hide();
          $("#visibleProjectFile").hide();
        } else {
          $("#addProjectFile").show();
          $("#updateProjectFile").show();
          $("#delProjectFile").show();
          $("#visibleProjectFile").show();
        }
        $("#ProjectFileRemenu").show();
        $("#ProjectFileRemenu").css({
          top: y + "px",
          left: x + "px",
          visibility: "visible",
        }); //设置右键菜单的位置、可见
        $("body").bind("mousedown", onBodyMouseDown);
      }

      $("#ProjectFileRemenu ul li")
        .unbind()
        .bind("click", function () {
          $("#ProjectFileRemenu").css({
            visibility: "hidden",
          });
          var type = $(this).attr("id");
          if (type == "addProjectFile") {
            var newNode = {},
              params = {};
            params = {
              pftr01: 0,
              pftr02: "新建资料目录",
              pftr03: _this.selectNode == null ? 0 : _this.selectNode.pftr01,
              pftr04: localStorage.getItem("xid"),
              pftr05: new Date(),
              pftr07: localStorage.id,
            };
            AddProjectFile(params).then((res) => {
              if (res.Code > 0) {
                _this.$message({
                  type: "success",
                  message: "添加成功",
                });
                newNode = res.Data;
                _this.zTeeObj.addNodes(_this.selectNode, newNode);
                var currentNode = _this.zTeeObj.getNodeByParam(
                  "pftr01",
                  newNode.pftr01
                );
                _this.zTeeObj.selectNode(currentNode);
                _this.zTeeObj.editName(currentNode);
              } else {
                _this.$message({
                  type: "waring",
                  message: "添加失败",
                });
              }
            });
          } else if (type == "delProjectFile") {
            _this.$confirm("确认删除当前以及附属节点？").then((_) => {
              var treeNodes = _this.zTeeObj.transformToArray(_this.selectNode);
              var ids = "",
                _split = "";
              treeNodes.forEach((element) => {
                ids += _split + element.pftr01;
                _split = ",";
              });
              let params = { xid: localStorage.getItem("xid"), zid: ids };
              DelProjectFile(params).then((res) => {
                if (res.Code > 0) {
                  _this.$message({
                    type: "success",
                    message: "删除成功",
                  });
                  var currentNode = _this.zTeeObj.getNodeByParam(
                    "pftr01",
                    _this.selectNode.pftr01
                  );
                  _this.zTeeObj.removeNode(currentNode);
                } else {
                  _this.$message({
                    type: "warning",
                    message: "删除失败",
                  });
                }
              });
            });
          } else if (type == "WorkPlaneLink") {
            _this.associated(_this.selectNode);
          } else if (type == "visibleProjectFile") {
            _this.getData2();
            if (_this.selectNode.pftr09) {
              let uids = _this.selectNode.pftr09.split(",").map(Number);
              _this.selectUsers = _this.allUsers.filter((x) =>
                uids.includes(x.user01)
              );
              _this.selectUserIds = _this.selectUsers.length
                ? _this.selectUsers.map((item) => item.user01)
                : [];
            }
            _this.visibleProjectFileShow = true;
          } else {
            _this.zTeeObj.editName(_this.selectNode);
          }
        });

      function beforeRename(treeId, treeNode, newName, isCancel) {
        if (newName != treeNode.pftr02) {
          let params = {
            zid: treeNode.pftr01,
            name: newName,
          };
          EditProjectFile(params).then((res) => {
            _this.$message({
              type: "success",
              message: "更新成功",
            });
          });
        }
      }
    },
    // 获取所有数据
    getData() {
      let params = {
        zid: this.ids,
      };
      this.tableLoading = true;
      FindProjectFileInfo(params).then((res) => {
        this.tableLoading = false;
        this.inform = res.Data;
      });
    },
    GetProjectFileZTree() {
      let params = {
        xid: localStorage.getItem("xid"),
        all: true,
      };
      GetProjectFileZTree({ params }).then((res) => {
        this.zNodes = res.Data || [];
        this.init();
      });
    },
  },
  created() { },
  mounted() {
    this.GetProjectFileZTree();
    this.getAllUser();
  },
};
</script>

<style lang="less" scoped>
.middle {
  display: flex;
  // justify-content: center; /*主轴上居中*/
  align-items: center;
  /*侧轴上居中*/
}

div#ProjectFileRemenu {
  position: fixed;
  visibility: hidden;
  top: 0;
  width: 60px;
  background-color: #35a5db;
  padding: 4px;
  border-radius: 3px;
  overflow: auto;
  border: 1px solid #eee;
}

div#ProjectFileRemenu ul {
  margin: 0px;
  padding: 0px;
}

div#ProjectFileRemenu ul li {
  font-size: 12px;
  line-height: 20px;
  margin: 0px;
  padding: 0px;
  cursor: pointer;
  list-style: none outside none; //取消样式
  background-color: rgba(255, 255, 255, 0);
  padding-left: 3px;
  margin: 1px auto;
  color: white;
  border-radius: 3px;
  letter-spacing: 1px;
}

div#ProjectFileRemenu ul li:hover {
  background: #eee;
  color: #000000;
}

#ProjectFileTree {
  height: 500px;
}

.zTreeDiv {
  overflow: auto;
}

.ztree li span {
  // color: #fff;
  line-height: 21px;
  margin-right: 2px;
}

// 新增
.font-sz24 {
  font-size: 24px;
}

.head-text {
  float: right;
  margin-top: -4px;
}

.float-r {
  float: right;
}

.float-r-mar-r10 {
  float: right;
  margin-right: 10px;
}

.mar-top20 {
  margin-top: 20px;
}

.elAside {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  text-align: center;
}

.w100-mar-bom20 {
  width: 100%;
  margin-bottom: 20px;
}

.cor-red {
  color: red;
}

.mar-left10 {
  margin-left: 10px;
}
</style>
